import { useState } from 'react';
import DelegateInput from '../DelegateInput';

/**
 * InlineWaitingForm - Compact form for delegating or setting waiting status
 *
 * Uses simple text input with autocomplete for delegate names.
 * Converts text input to delegate object for the new delegation system.
 */
export default function InlineWaitingForm({ onConfirm, onCancel, delegates = [] }) {
  const [delegatedTo, setDelegatedTo] = useState('');
  const [waitingFor, setWaitingFor] = useState('');
  const [followUpDate, setFollowUpDate] = useState('');

  const handleConfirm = () => {
    // Convert delegate name to object format if provided
    const delegateObj = delegatedTo.trim() ? {
      uid: null,  // Will be matched to linked account in moveToWaiting if possible
      name: delegatedTo.trim(),
      email: null,
      isExternal: true
    } : null;

    onConfirm(
      waitingFor || null,
      delegateObj,
      followUpDate || null
    );
  };

  const hasData = delegatedTo.trim() || waitingFor.trim();

  return (
    <div className="flex flex-col gap-2 bg-surface-elevated p-3 rounded-lg border border-amber-500/30 min-w-[220px]">
      {/* Delegate input */}
      <DelegateInput
        value={delegatedTo}
        onChange={setDelegatedTo}
        delegates={delegates}
        placeholder="Delegate to..."
        autoFocus
      />

      {/* Divider */}
      <div className="flex items-center gap-2 my-1">
        <div className="flex-1 h-px bg-border"></div>
        <span className="text-[10px] text-text-tertiary">or</span>
        <div className="flex-1 h-px bg-border"></div>
      </div>

      {/* Non-delegation waiting */}
      <input
        type="text"
        placeholder="Waiting for... (e.g., vendor)"
        value={waitingFor}
        onChange={(e) => setWaitingFor(e.target.value)}
        className="py-1.5 px-2 bg-surface-card border border-border rounded text-xs text-text-primary focus:border-amber-500 focus:outline-none"
        disabled={!!delegatedTo.trim()}
      />

      {/* Follow-up date */}
      <div className="flex items-center gap-2">
        <span className="text-[10px] text-text-tertiary whitespace-nowrap">Follow up:</span>
        <input
          type="date"
          value={followUpDate}
          onChange={(e) => setFollowUpDate(e.target.value)}
          className="flex-1 py-1 px-2 bg-surface-card border border-border rounded text-xs text-text-primary"
        />
      </div>

      {/* Actions */}
      <div className="flex gap-2 mt-1">
        <button
          onClick={handleConfirm}
          disabled={!hasData}
          className="flex-1 py-2 bg-amber-500 text-white rounded text-xs font-medium border-none cursor-pointer hover:bg-amber-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Save
        </button>
        <button
          onClick={onCancel}
          className="px-4 py-2 bg-surface-hover text-text-secondary rounded text-xs border-none cursor-pointer hover:bg-surface-card transition-all"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
